import { trpc } from './trpc';
import { inferRouterOutputs, inferRouterInputs } from '@trpc/server';
import { AppRouter } from '@tagadapay/trpc-types';
import { useToast } from '@/components/ui/use-toast';

type OutputRouter = inferRouterOutputs<AppRouter>;
type InputRouter = inferRouterInputs<AppRouter>;

// Output types
export type UploadMediaOutput = OutputRouter['media']['upload'];

// Input types
export type UploadMediaInput = InputRouter['media']['upload'];

// Hook for uploading media (images and videos)
export const useUploadMedia = () => {
  const utils = trpc.useUtils();
  const { toast } = useToast();
  return trpc.media.upload.useMutation({
    onSuccess: (data) => {
      utils.media.invalidate();
      toast({
        title: 'Success',
        description: data.file.isVideo
          ? 'Video uploaded successfully'
          : 'Image uploaded successfully',
      });
    },
  });
};
